module.exports = __webpack_public_path__ + "static/img/pic_pptyauso_132＊132@2x.d9e1428a.png";